module.exports = __webpack_public_path__ + "static/media/footerlogonew.516a9ea2.svg";